import { create } from 'zustand';

type ISearchContentStore = {
  hasFiltersApplied: boolean;
  setHasFiltersApplied: (hasFiltersApplied: boolean) => void;
};

export const useSearchContentStore = create<ISearchContentStore>((set) => ({
  hasFiltersApplied: false,
  setHasFiltersApplied: (hasFiltersApplied: boolean) =>
    set({ hasFiltersApplied }),
}));
